// extracted by mini-css-extract-plugin
module.exports = {"container":"e_YH","readReviewButton":"e_ZH","arrowRight":"e__H","imageContainer":"e_0H","image":"e_1H","badge":"e_2H","badgeImage":"e_3H","content":"e_4H","title":"e_5H"};